<template>
    <div class="container">
        <b-row>
            <b-container>
                <h2 class="text-center">
                    {{labels.title}}
                </h2>
            </b-container>
        </b-row>
        <b-row v-if="!isLoading">
            <b-container>
                <div class="col-md-12 d-flex justify-content-end">
                    <td>
                        <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="crearMenu()">
                            <md-icon>add</md-icon>
                        </md-button>
                    </td>
                </div>
                <div class="row col-md-12 justify-content-center">
                    <md-table md-card md-header v-model="listMenus">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell :md-label="labels.nombre" class="border">{{ item.nombre }}</md-table-cell>
                        <md-table-cell :md-label="labels.ruta" class="border">{{ item.ruta }}</md-table-cell>
                        <md-table-cell :md-label="labels.icono" class="border">{{ item.icono }}</md-table-cell>
                        <md-table-cell :md-label="labels.orden" class="border">{{ item.orden }}</md-table-cell>
                        <md-table-cell :md-label="labels.edit" class="border">
                            <md-button style="background-color: #e5ac00; width: 35px; height: 35px;" class="md-fab md-primary" @click="editMenu(item.id)">
                                <md-icon>edit</md-icon>
                            </md-button>
                        </md-table-cell>
                        <md-table-cell :md-label="labels.rol" class="border">
                            <md-button style="background-color: #912710; width: 30px; height: 30px;" class="md-fab md-primary" @click="listarRoles(item.id)">
                                <md-icon><font-awesome-icon :icon="['fas', 'user']" /></md-icon>
                            </md-button>
                        </md-table-cell>
                        </md-table-row>
                    </md-table>
                </div>
            </b-container>
        </b-row>
        <Crear :modCrearMenu="modCrearMenu" @closeModal="closeModal"/>
        <Editar :modEditarMenu="modEditarMenu" :infoMenu="datosMenu" @closeModal="closeModal"></Editar>
        <AsociaDesasociaRol :modAsociaDesasociaRol="modalRoles" :infoMenu="datosMenu" @closeModal="closeModal"/>
    </div>
</template>
<script>
import Menu from '../../../services/Menu';
import Crear from './Crear.vue';
import Editar from './EditarMenu.vue';
import AsociaDesasociaRol from './AsociaDesasociaRol.vue';

export default {
    name:'AdministradorMenu',
    components:{
        Crear,
        Editar,
        AsociaDesasociaRol
    },
    data: () => ({
        isLoading: false,
        listMenus : [],
        modCrearMenu: false,
        modEditarMenu: false,
        modalRoles: false,
        datosMenu: []
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Menús",
                    nombre : "Nombre",
                    ruta : "Url",
                    icono : "Icono",
                    edit : "Editar",
                    rol : "Roles",
                    orden : "Orden",
                }
            }else{
                return {
                    title : "Menu",
                    nombre : "Name",
                    ruta : "Url",
                    icono : "Icon",
                    edit : "Edit",
                    rol : "Role",
                    orden : "Order",
                }
            }
        }
    },
    mounted(){
        Menu.getAllMenu()
        .then((res) => {
            // console.log(res.data)
            this.listMenus = res.data.listMenu
        })
        .catch((err) => {
            console.log(err)
        })
    },
    methods:{
        closeModal(val){
            this.modCrearMenu = val
            this.modEditarMenu = val
            this.modalRoles = val
        },
        crearMenu(){
            this.modCrearMenu = true
        },
        editMenu(idMenu){
            // console.log(idMenu)
            Menu.getMenuById(idMenu)
            .then((res) => {
                // console.log(res.data.menu)
                this.datosMenu = res.data.menu
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.modEditarMenu = true
            })
        },
        listarRoles(idMenu){
            // console.log("LISTAR: ",idMenu)
            Menu.getMenuById(idMenu)
            .then((res) => {
                // console.log(res.data.menu)
                this.datosMenu = res.data.menu
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.modalRoles = true
            })
        }
    }
}
</script>

<style>

</style>
